/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Selection_EmptyInputs */



/**
* | output |
* | --- |
* | "Select at least one model." |
*
* @param {Private_Models_Save_Selection_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_selection_empty = /** @type {((inputs?: Private_Models_Save_Selection_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Selection_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie mindestens ein Modell aus.")
	return /** @type {LocalizedString} */ ("Select at least one model.")
});